<template>
    <b-container>
    <div style="height: 450px; width: 100%">
<!--        <div style="overflow: auto; height: 20px;">-->
<!--            <p>Последнее местоположение: {{ withPopup.lat }}, {{ withPopup.lng }}</p>-->
<!--            <p>Center is at {{ currentCenter }} and the zoom is: {{ currentZoom }}</p>-->
<!--            <button @click="showLongText">-->
<!--                Toggle long popup-->
<!--            </button>-->
<!--            <button @click="showMap = !showMap">-->
<!--                Toggle map-->
<!--            </button>-->
<!--        </div>-->
        <l-map
            v-if="visible"
            :zoom="zoom"
            :center="center"
            :options="mapOptions"
            style="height: 99%"
            @update:center="centerUpdate"
            @update:zoom="zoomUpdate"
            ref="mapHistory"
        >
            <l-tile-layer
                :url="url"
                :attribution="attribution"
            />
          <l-polyline :lat-lngs="polyline.latlngs" :color="polyline.color"></l-polyline>

          <button id="btnCheckPopup" ref="btnCheckPopup">check popup</button>
          <span id="popupStatus" ref="popupStatus"></span>
            <l-marker ref="popupWindow" v-if="withPopup.visible" :lat-lng="withPopup.point">
              <l-popup>
                <div>11111</div>
              </l-popup>
            </l-marker>
            <l-marker v-for="point in points" :key="point.identity" :lat-lng=point.latlng :icon="icon">
                <l-popup>
                    <div>
                      date: {{point.date}} <br>
                      course: {{point.course}}<br>
                      height: {{point.height}}<br>
                      satellites: {{point.satellites}}<br>
                      speed: {{point.speed}}
                    </div>
                </l-popup>
            </l-marker>
        </l-map>
    </div><div>
      <b-form @submit.prevent="onSubmit">
      <b-row>
        <b-col>
          <b-input-group class="mb-3">
              <b-form-datepicker
                  v-model="form.from"
                  button-only
                  right
                  locale="en-US"
                  aria-controls="from"
                  @context="onContext"
              />
              <b-form-input
                  v-model="form.from"
                  type="text"
                  placeholder="YYYY-MM-DD"
                  autocomplete="off"
              />
            <b-input-group-append>
              <b-form-input
                  v-model="form.from_time"
                  type="text"
                  placeholder="HH:mm:ss"
              />
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col>
          <b-input-group class="mb-3">
            <b-form-datepicker
                v-model="form.to"
                button-only
                right
                locale="en-US"
                aria-controls="to"
                @context="onContext"
            />
            <b-form-input
                v-model="form.to"
                type="text"
                placeholder="YYYY-MM-DD"
                autocomplete="off"
            />
            <b-input-group-append>
              <b-form-input
                  v-model="form.to_time"
                  type="text"
                  placeholder="HH:mm:ss"
              />
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <div class="mb-3">
        <b-button type="submit" variant="primary">{{$t('apply')}}</b-button>
        </div>
      </b-row>
      </b-form>
      <b-row>
      <b-col sm="5" md="6" class="my-1">
        <b-form-group
            label="Per page"
            label-for="per-page-select"
            label-cols-sm="6"
            label-cols-md="4"
            label-cols-lg="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
        >
          <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
              size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="sm"
            class="my-0"
        ></b-pagination>
      </b-col>
      </b-row>
      <b-table dark
               :busy.sync="isBusy"
               ref="table"
               id="collector-packet-list"
               :items="items"
               :per-page="perPage"
               :current-page="currentPage"
               :hover="hover"
               head-variant="dark"
               small
               :fields="fields"
               :filter-included-fields="filterOn"
               stacked="md"
               striped
               :sort-by.sync="sorting.sortBy"
               :sort-desc.sync="sorting.sortDesc"
               primary-key="id"
               @row-clicked="onRowClicked"
               @filtered="onFiltered"
      >
        <template v-slot:head()="scope">

          <div class="text-nowrap">
            {{  $t(scope.label) }}
          </div>
        </template>
        <template v-slot:cell(parameters)="row">

          <span
              class="d-inline-block text-truncate" style="max-width: 700px;"
              :title="row.item.parameters"
          >
            {{ row.item.parameters }}
          </span>
        </template>
<!--        <template v-slot(selected)="{ rowSelected }">-->
<!--           {{centerUpdate(rowSelected.item.point)}}-->
<!--        </template>-->
      </b-table>
      <div v-if="notDataVisible">
        {{$t('data.empty')}}
      </div>
    </div>
    </b-container>
</template>

<script>
import L, { latLng } from "leaflet";
import {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LPolyline
    // LTooltip
} from "vue2-leaflet";
import { Icon } from 'leaflet';
import axios from "axios";


delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
    name: "MonitoringHistory",
    props: {
        id: {
            type: Number
        },
        visible: {
            type: Boolean
        }
    },
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LPolyline
        // LTooltip
    },
    data() {
        return {
            isBusy: false,
            zoom: 13,
            center: latLng(55.7537, 37.619813),
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution: "",
            withPopup: {
              point: latLng(55.7537, 37.619813),
              data: {},
              visible:false,
              popup: {
                options: {
                    // keepInView:true
                }
              }
            },
            // withTooltip: latLng(55.7537, 37.619813),
            currentZoom: 11.5,
            currentCenter: latLng(55.7537, 37.619813),
            showParagraph: false,
            mapOptions: {
                // zoomSnap: 0.5
            },
            polyline: {
              latlngs: [],
              color: 'red'
            },
            icon: L.icon({
              iconUrl: 'assets/images/red-dot.png',
              iconSize: [10, 10],
              iconAnchor: [5, 5]
            }),
            points: [],
            notDataVisible: false,
            showMap: false,
            updateAvailable: true,
            hover: true,
            items: [],
            fields: [],
            filterOn: [],
            perPage: 15,
            totalRows: 1,
            currentPage: 1,
            pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
            form: {
              from: '',
              from_time: '00:00:00',
              to: '',
              to_time: '23:59:59'
            },
            pagination: {
              currentPage: 1,
              rows: 0,
            },
            sorting: {
              sortBy: 'customId',
              sortDesc: true,
            },
            filters: {
                from_date: null,
                from_time: '00:00:00',
                to_date: null,
                to_time: '23:59:59'

            },
            filterListTable: {

            },
        };
    },
    methods: {
      onSubmit() {
        // event.preventDefault()
        // console.log(this.form)
        // alert(1111)
        // alert(JSON.stringify(this.form))
        this.loadData();
      },
        zoomUpdate(zoom) {
            this.currentZoom = zoom;
        },
        centerUpdate(center) {
            // alert(111)
            this.currentCenter = center;
            // console.log('map was moved')
        },
        onRowClicked(item) {
        // console.log(item)
          if (item.point !== null) {

            // this.withPopup = item.point;

            // this.withPopup.point = item.point;
            // this.withPopup.visible = true;

            const map = this.$refs.mapHistory.mapObject;

            // console.log(item)

            const popupContent = document.createElement('div');
            popupContent.appendChild(document.createTextNode('date:' + item.date));
            popupContent.appendChild(document.createElement('br'));
            popupContent.appendChild(document.createTextNode('coordinates:' + item.coordinates));
            popupContent.appendChild(document.createElement('br'));

            const myPopup = L.popup()
                .setLatLng(item.point)
                .setContent(popupContent)
                .openOn(map);

            this.$refs.btnCheckPopup.onclick = () => {
              let status = myPopup.isOpen()? 'popup is open' : 'popup is closed';
              document.querySelector('#popupStatus').innerHTML = status;
            }

            // myPopup.openPopup(item.point)


            this.setCenter(item.point);
          }
        },
        showLongText() {
            this.showParagraph = !this.showParagraph;
        },
        innerClick() {
            alert("Click!");
        },
        setCenter(center) {
            const mapComponent = this.$refs.mapHistory;
            mapComponent.setCenter(center)
            mapComponent.mapObject.flyTo(center)
          // console.log(center);
        },
        onContext(ctx) {
          this.context = ctx
        },
        loadData() {
        // console.log(ctx)
        // Here we don't set isBusy prop, so busy state will be
        // handled by table itself

        let param = {
            }
        ;

          param.from = this.form.from + ' ' + this.form.from_time;
          param.to = this.form.to + ' ' + this.form.to_time;

        // this.isBusy = true
        let promise = axios.get(
            'api/v1/devices/' + this.id + '/packets',
            { params: param }
        )

        return promise.then((data) => {


          this.notDataVisible = false;

          const items = [];
          let id = 1;

          this.polyline.latlngs = [];
          this.points = [];

          data.data.records.forEach(
              item => {
                let point = null;

                if (item.coordinates.latitude !== null &&  item.coordinates.longitude != null) {
                  point = latLng(item.coordinates.latitude, item.coordinates.longitude);
                  this.polyline.latlngs.push(point);
                  this.points.push(
                      {
                        identity:item.identity,
                        latlng:point,
                        date: item.date,
                        course: item.coordinates.course,
                        height: item.coordinates.height,
                        satellites: item.coordinates.satellites,
                        speed: item.coordinates.speed
                      }
                  );
                }
                //
                // let param = '';

                const paramsMap = {
                    LAT: 'latitude',
                    LNG: 'longitude',
                    EXT_VOLT: 'voltage',
                    INT_VOLT: 'acc',
                    SPEED: 'speed',
                    GPS_SAT: 'gps',
                    GLONASS_SAT: 'glonass',
                    HEIGHT: 'height',
                    COURSE: 'course',
                    DEV_ST_IN0: 'in0',
                    DEV_ST_IN1: 'in1',
                    DEV_ST_IN2: 'in2',
                    DEV_ST_IN3: 'in3',
                    DEV_ST_IN4: 'in4',
                    DEV_ST_IN5: 'in5',
                    DEV_ST_IN6: 'in6',
                    DEV_ST_IN7: 'in7',
                    DEV_ST_OUT0: 'out0',
                    DEV_ST_OUT1: 'out1',
                    DEV_ST_OUT2: 'out2',
                    DEV_ST_OUT3: 'out3',
                    DEV_ST_GSM_ST: 'gsmSt' ,
                    DEV_ST_NAV_ST: 'navSt',
                    DEV_ST_MW: 'mv',
                    DEV_ST_SIM_T: 'simT',
                    DEV_ST_SIM_IN: 'simIn',
                    DEV_ST_ST0: 'st0',
                    DEV_ST_ST1: 'st1',
                    DEV_ST_ST2: 'st2',
                    DEV_ST_PWR_IN: 'pwrIn',
                    DEV_ST_PWR_EXT: 'pwrExt',
                    HARD_VR: 'hardwareVersion',
                    SOFT_VR: 'softwareVersion',
                    HARD_ST: 'hardwareStatus',
                }

                let params = {
                    id: id++,
                    date: item.date,
                    coordinates: item.coordinates.latitude + ' ' + item.coordinates.longitude,
                    // parameters: param,
                    // latitude: item.coordinates.latitude,
                    // satellites: item.coordinates.longitude,
                    // speed: item.coordinates.longitude,
                    // gps: item.coordinates.longitude,
                    // gsm: item.coordinates.longitude,
                    // mv: item.coordinates.longitude,
                    // voltage: item.voltage.externalVoltage,
                    // acc: item.voltage.internalVoltage,
                    // output: item.coordinates.longitude,
                    // input: item.coordinates.longitude,
                    point: point != null ? point : null
                }

                  // console.log(item.parameterList)

                for (const [key, value] of Object.entries(item.parameterList)) {

                    // console.log(key + value)

                    if (paramsMap[key] !== undefined) {

                        if (
                            key === paramsMap.EXT_VOLT
                             ||
                            key === paramsMap.INT_VOLT
                              ||
                            key === paramsMap.SPEED
                        ) {
                            params[paramsMap[key]] = (Math.round(value * 100) / 100).toFixed(2);
                        } else {
                            params[paramsMap[key]] = value;
                        }
                    }
                }

                items.push(
                    params
                )
              }
          )

// zoom the map to the polyline
//           this.$refs.map.fitBounds(this.this.polyline.latlngs.getBounds());

          this.totalRows = data.data.records.length;

          if (!this.totalRows > 0) {
            this.notDataVisible = true;
          }

          // Here we could override the busy state, setting isBusy to false
          // this.pagination.rows = data.data.records
          // console.log(data.data)
          // this.isBusy = false

          // localStorage.setItem('deviceListFilters', JSON.stringify(this.filters));
          // localStorage.setItem('deviceListPagination', JSON.stringify(this.pagination));
          // localStorage.setItem('deviceListSorting', JSON.stringify(this.sorting));

          this.items = items;

          this.$refs.mapHistory.fitBounds([
            this.polyline.latlngs
          ])

          return(items)
        }).catch(() => {
          this.notDataVisible = true;

          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          // Returning an empty array, allows table to correctly handle
          // internal busy state in case of error
          // console.log(error)
          return []
        })
      },
        onFiltered(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRows = filteredItems.length
          this.currentPage = 1
        },
        updateFields() {
        let index = 0;

        this.fields = [];
        this.availableColumns.forEach(
            column => {
              column.order = ++index;
              if (column.visible === true) {
                column.label = this.$t(column.label_t)

                this.fields.push(column);
              }
            }
        )
      },
        selectSelected() {
        // console.log('select');
        // console.log(this.$refs.table);
        // console.log(this.$refs.table.renderBusy());
        // console.log(this.$refs.table.busy);

        // let t = this.$refs.table;
        // let s = [];
        //
        // this.selected.forEach(
        //     (value, index) => {
        //       s[index] = value;
        //     }
        // )

      },
    },
    mounted() {
      this.updateFields();

      Date.prototype.yyyymmdd = function() {
        const mm = this.getMonth() + 1; // getMonth() is zero-based
        const dd = this.getDate();

        return [this.getFullYear(),
          (mm>9 ? '' : '0') + mm,
          (dd>9 ? '' : '0') + dd
        ].join('-');
      };

      const now = new Date();
      this.form.from = now.yyyymmdd();
      this.form.to = now.yyyymmdd();
    },
    computed: {
      availableColumns: {
        get() {
          return this.$store.state.packetsHistoryTableFields;
        },
      }
    },
    created() {
    }
};
</script>
